import api from './api'

/**
 * Admin-only organization management API (super admin).
 * Mirrors the write endpoints added under /api/admin/organizations.
 */
export const organizationAdminService = {
  async adminCreate(payload) {
    const { data } = await api.post('/admin/organizations', payload)
    return data
  },

  async adminUpdate(id, payload) {
    const { data } = await api.patch(`/admin/organizations/${id}`, payload)
    return data
  },

  async adminAddMember(organizationId, { userId, role }) {
    const { data } = await api.post(`/admin/organizations/${organizationId}/members`, {
      userId,
      role
    })
    return data
  },

  async adminUpdateMemberRole(organizationId, membershipId, role) {
    const { data } = await api.patch(
      `/admin/organizations/${organizationId}/members/${membershipId}`,
      { role }
    )
    return data
  },

  async adminRemoveMember(organizationId, membershipId) {
    const { data } = await api.delete(
      `/admin/organizations/${organizationId}/members/${membershipId}`
    )
    return data
  }
}

export default organizationAdminService
